export default __webpack_public_path__ + "static/media/img9.a00e3452.png";